<template>
  <div class="list-item">
    <div v-show="loading" style="min-height:466px;padding: 50% 0;">
      <Stretch>Carregando...</Stretch>
    </div>
    <div v-show="loading === false" class="container-seguirleiloeiro">
      <Carousel
        v-if="dados.fotos && dados.fotos.length > 0 && !isTablet"
        :contexto="contexto"
        :paginationEnabled="true"
        :navigationEnabled="true"
        :loop="true"
        :perPage="1"
      >
        <Slide v-for="(foto, index) in dados.fotos" :key="index">
          <img
            :src="foto.nm_path_completo"
            :alt="`Imagem ${index + 1}`"
            style="width: 100%; height: auto;"
          />
        </Slide>
      </Carousel>
      <div v-else-if="!isTablet" class="item-sem-foto">
        <img v-if="mainDomain !== 'meirelesleiloes'"
             src="https://906de634c48fb7d34136160b4c353ae4.s3.sa-east-1.amazonaws.com/public/leiloesjudiciaissul/layout/images/sem_foto.png"
             alt="Lote sem foto">
        <img v-else
             src="https://906de634c48fb7d34136160b4c353ae4.s3.sa-east-1.amazonaws.com/public/meirelesleiloes/layout/images/nao-disponivel.jpg"
             alt="Lote sem foto">
      </div>
      <div class="right-content-lote">
        <div class="max-descricao-content">
          <div v-if="status ? status.toLowerCase().indexOf('trt') !== -1 : false">
            <div class="product-des">
              <p v-html="dados.nm_descricao"></p>
            </div>
          </div>
          <div v-else class="descricao-lote-seguirleiloeiro">
            <p v-html="dados.nm_descricao"></p>
          </div>
        </div>

        <div v-if="status ? status.toLowerCase().indexOf('trt') !== -1 : false">
          <div v-show="dados.judicial && Object.keys(dados.judicial).length > 0" class="info-judiciais row">
            <div v-for="(vistoria, idv) in dados.vistoria" :key="idv">
              <!-- Imovel, exibir endereço do bem -->
              <div v-if="vistoria.imovel_id > 0">
                <div style="margin-left: 15px; margin-bottom:10px; ">
                  <p><strong>Endereço: </strong> {{ vistoria.i_nm_endereco }}, {{ vistoria.i_nm_bairro }},
                    {{ vistoria.i_nm_cidade }} / {{ vistoria.i_nm_estado }}. </p>
                </div>
              </div>
              <!-- Outras vistorias, exibir endereço da filial -->
              <div v-else-if="vistoria.equipamento_id > 0">
                <div style="margin-left: 15px; margin-bottom:10px; ">
                  <p><strong>Endereço: </strong> {{ vistoria.e_nm_localexposicao }} </p>
                </div>
              </div>
              <div v-else-if="vistoria.veiculo_id > 0">
                <div style="margin-left: 15px; margin-bottom:10px; ">
                  <p><strong>Endereço: </strong> {{ vistoria.v_nm_localexposicao }} </p>
                </div>
              </div>
            </div>
            <div>
              <div class="col-lg-4 col-md-4">
                <p>
                  <strong>Processo: </strong>
                  <span class="display-block">{{ infoJudicial(dados.judicial.nu_processo) }}</span>
                </p>
                <p>
                  <strong>Exequente: </strong>
                  <span class="display-block">{{ infoJudicial(dados.judicial.nm_exequente) }}</span>
                </p>
                <p>
                  <strong>Executado: </strong>
                  <span class="display-block">{{ infoJudicial(dados.judicial.nm_executada) }}</span>
                </p>
                <p>
                  <strong>Edital: </strong>
                  <span class="display-block">{{ infoJudicial(dados.judicial.nm_edital) }}</span>
                </p>
                <p>
                  <strong>Avaliação: </strong>
                  <span class="display-block">{{ infoJudicial(dados.vl_avaliacaoleiloeiro) }}</span>
                </p>
              </div>
              <div class="col-lg-4 col-md-4">
                <p>
                  <strong>Hora Leilão: </strong>
                  <span class="display-block">{{ infoJudicial(dados.judicial.nm_horaleilao) }}</span>
                </p>
                <p>
                  <strong>Vara: </strong>
                  <span class="display-block">{{ infoJudicial(dados.judicial.nm_vara) }}</span>
                </p>
                <p>
                  <strong>D.O.E: </strong>
                  <span class="display-block">{{ infoJudicial(dados.judicial.nm_doe) }}</span>
                </p>
                <p v-if="dados.judicial.nm_praca">
                  <strong>Leilão: </strong>
                  <span class="display-block">{{ infoJudicial(dados.judicial.nm_praca) }}</span>
                </p>
                <p v-if="dados.judicial.nm_municipio">
                  <strong>Município: </strong>
                  <span class="display-block">{{ infoJudicial(dados.judicial.nm_municipio) }}</span>
                </p>
                <p>
                  <strong>Publicação: </strong>
                  <span class="display-block">{{ infoJudicial(dados.judicial.nm_publicacao) }}</span>
                </p>
              </div>
              <div class="col-lg-4 col-md-4">
                <div class="ultimos-lances" v-if="dados.historico_lances">
                  <!-- ULTIMOS LANCES AINDA NAO DEFINIDO NO BACKEND -->
                  <h2>Ultimos lances</h2>
                  <table class="table-lances">
                    <tr>
                      <th>Usuário</th>
                      <th>Lance</th>
                    </tr>
                    <tbody>
                    <tr v-for="(lance,idx) in dados.historico_lances.slice(0, 5)" :key="idx">
                      <td class="nm-usuario-limit" :title="lance.nm_usuario">{{ lance.nm_usuario }}</td>
                      <td style="text-align: right;">{{ formatarPreco(lance.vl) }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <card
        :leilao="leilao"
        :dados="dados"
        :liberado="liberado"
        :automatico="automatico"
        :usuarioid="usuarioid"
        :dadosCondicao="dadosCondicao"
        contexto="item"
        @atualizarFavoritos="atualizarFavoritos"
      ></card>
    </div>
  </div>
</template>
<script>
import Card from '@/components/shared/Card'
import Carousel from '@/components/customCarousel/Carousel'
import Slide from '@/components/customCarousel/Slide'
import {Stretch, Circle6} from 'vue-loading-spinner'
import seguirLeiloeiro from "./SeguirLeiloeiro.vue";

export default {
  name: 'Item',
  data() {
    return {
      errors: [],
      loading: false,
      pathName: location.protocol + "//" + window.HOSTNAME,
      is_favorito: false,
      contexto: 'item',
      screenWidth: window.innerWidth,
    }
  },
  components: {
    Carousel,
    Stretch,
    Circle6,
    Slide,
    Card
  },
  props: [
    'leilao',
    'dados',
    'liberado',
    'automatico',
    'usuarioid',
    'status',
    'exibirvideo',
    'dados_condicao',
    'dadosCondicao',
    'saladisputa'
  ],
  methods: {
    atualizarFavoritos() {
      if (this.saladisputa && typeof this.saladisputa.configuraFavoritos === 'function') {
        this.saladisputa.configuraFavoritos();
      } else {
        console.error('saladisputa ou configuraFavoritos não está definido.');
      }
    },
    infoJudicial(dadoJudicial) {
      return dadoJudicial ? dadoJudicial : 'Não informado'
    },
    formatarPreco(value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return 'R$ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  },
  computed: {
    seguirLeiloeiro() {
      return seguirLeiloeiro
    },
    isNotebook() {
      return this.screenWidth <= 1024;
    },
    isTablet() {
      return this.screenWidth <= 768;
    },
    isMobile() {
      return this.screenWidth <= 435;
    },
    mainDomain() {
      const domainParts = window.location.hostname.split('.');
      return domainParts.length > 2 ? domainParts[1] : domainParts[0];
    }
  },
}
</script>
<style scoped>
.container-seguirleiloeiro {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  max-height: 382px;
}

.VueCarousel {
  justify-content: center;
}

.VueCarousel-slide img,
.VueCarousel-wrapper {
  border-radius: 10px;
}

.right-content-lote {
  background-color: #f6f6f6;
  border-radius: 10px;
}

.right-content-lote,
.VueCarousel {
  width: 35.5%;
}

.max-descricao-content {
  padding: 10px;
}

.descricao-lote-seguirleiloeiro {
  padding: 10px;
  max-height: 363px;
  max-width: 415px;
  overflow-y: auto;
}

#portotemplate .product-actions a.addtocart {
  font-size: 23px;
  height: auto;
  line-height: normal;
  padding: 5px 9px;
  bottom: -100px;
}

.product-des {
  padding: 6px;
}

.product-des p {
  min-height: 100px;
  max-height: 152px;
  overflow: auto;
  display: block;
  width: 100%;
}

.product-des p::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(255, 255, 255, 0.5);
  background-color: #F5F5F5;
}

.product-des p::-webkit-scrollbar {
  width: 6px;
  background-color: #F5F5F5;
}

.product-des p::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background-color: #0a1a3d;
}

.new {
  color: #716f6f;
}

.maior-lance {
  background: #ebe267d1;
  padding: 1px 29px;
  position: absolute;
  bottom: -41px;
  width: 100%;
  left: 0;
}

.product-details-area {
  position: relative;
}

.envia-lance-label {
  position: absolute;
  color: #393939;
  width: 120px;
  right: -113px;
  bottom: -3px;
  font-size: 13px !important;
}

.product-actions {
  position: absolute;
  bottom: 0;
}

#portotemplate .product.product-list .product-actions a.addtocart {
  background: #67302b !important;
  border-color: #67302b !important;
  color: #fff !important;
}

#portotemplate .product .product-quickview,
#portotemplate .product:hover .product-actions a.addtocart {
  background: #508047 !important;
  border-color: #51764b !important;
  color: #fff !important;
}

.add-favorito {
  top: 10px;
  right: 10px;
}

#portotemplate .product .product-image-area {
  min-height: 253px;
}

.info-judiciais {
  min-height: 200px;
}

.info-judiciais strong {
  font-size: 13px;
}

.info-judiciais span {
  font-size: 12px;
  color: #9e9e9e;
}

.list-item {
  padding: 15px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #fff;
}

.ultimos-lances .table-lances {
  width: 100%;
}

.ultimos-lances {
  background: #e2e2e2;
  padding: 4px;
  border-radius: 7px;
}

.ultimos-lances h2 {
  text-align: center;
  padding-top: 5px;
}

.ultimos-lances .table-lances th {
  text-align: center !important;
  background: #b7b7b7cc;
}

.ultimos-lances .table-lances td {
  text-align: left;
  padding: 4px;
}

.ultimos-lances .table-lances tr:nth-child(odd) {
  background: #fff;
}

.ultimos-lances .table-lances tr:nth-child(even) {
  background: #f2f2f2;
}

.nm-usuario-limit {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 12ch;
  position: absolute;
}

.item-sem-foto {
  display: flex;
  width: 35.5%;
  border-radius: 10px;
}

.item-sem-foto img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}

@media (max-width: 768px) {
  .right-content-lote {
    width: 50%;
  }

  .container-seguirleiloeiro {
    max-height: 695px !important;
  }

  .descricao-lote-seguirleiloeiro {
    max-height: 677px !important;
  }
}

@media (max-width: 435px) {
  .container-seguirleiloeiro {
    flex-direction: column-reverse;
    max-height: 1025px !important;
  }

  .right-content-lote {
    width: 100% !important;
  }

  .descricao-lote-seguirleiloeiro {
    max-height: 300px !important;
    max-width: 319px !important;
  }
}

@media (max-width: 900px) {
  .product-des p {
    width: 100%;
  }
}

@media (max-width: 600px) {
  .product-name.title-desc {
    margin-top: 50px !important;
  }

  .container-visita-incremento {
    top: -33px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Item.vue